import styled, { css } from "styled-components";


export const FlexContainer = styled.div`
    display: flex;
    flex-direction: ${props => props.direction || 'row'};
    justify-content: ${props => props.justify || 'start'};
    width: ${props => props.width}
    font-family: Calibri, Helvetica, sans-serif;
`
export const WrapperContainer = styled.div`
    padding: 20px 5px;
    width: ${props => props.width || '100%'};
    max-width: ${props => props.maxwidth || '100%'};
    font-family: Calibri, Helvetica, sans-serif;
    hr {
        margin: 30px 10px 0;
        background: #0000001f;
        transition: background .3s, opacity .3s;
        height: .5px;
        border: none;
    }
`
export const ProductsWrapper = styled.div`
    padding: 0px 28px;
`
export const ProductListTableContainer = styled.div`
    margin-top: 30px;
    width: 100%;
    min-height: 600px;
    max-height: 600px;
    overflow: auto;
    border: 1px solid #0000001f;
    table{
        border-collapse: initial;
        border-radius: 4px;
        border-spacing: 0;
        max-width: 100%;
        width: 100%;
        height: 100%;
        // overflow: auto;
        // border: 1px solid #0000001f;
        tr th {
            position: sticky;
            top: 0;
            z-index: 1;
            font-weight: 500;
            text-align: left;
            background-color: #fff;
            border-bottom: 1px solid #0000001f;
        }
        tr:not(:last-child)>td, tr th {
        border-bottom : 1px solid #0000001f;
        }
        tr {
            background: #fff !important;
            height: 48px;
            td, th {
                font-size: .75rem;
                padding: 7px 16px;
                white-space: nowrap;
            }
        }
        tr { td {cursor: pointer;} }
        tbody tr:nth-child(odd) {
            background: #f5f5f5 !important;
        }
    }
`
export const EmptyDataContainer = styled.div`
    height: 250px;
    padding: 10px;
    display: flex;
    gap: 1rem;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
`
export const NoResults = styled.div`
    color: #747474;
    font-size: 4vh;
    font-weight: 700;
    text-align: center;
`
export const TrySearch = styled.div`
    color: #b3b3b3;
    font-size: 3vh;
    margin-top: 1rem;
    text-align: center;
`
export const NoResultImage = styled.img`
    transition: opacity .28s ease-in;
    width: 10vw;
    opacity: .5; 
    @media screen and (max-width: 1200px){
    width: 17vw;
    }
`
export const ImageContainer = styled.div`
    @media screen and (max-width: 1200px){
        width: 100%;
        text-align: center;
    }
`